<template>

  <div id="app_content" class="admin admin-images">

    <h1 class="mt-0">Immagini catalogo articoli</h1>

    <p>In questa sezione puoi associare le immagini caricate sul b2b alle entità ricevute da esolver.</p>
    <p><strong>Usare la nomenclatura macrofamiglia-famiglia-categoria-colore nel nome del file.</strong></p>
    <p><em>Es. cin-c-lp-bb.jpg</em></p>
    <br>
    <p>Se il file esiste già verrà sovrascritto da quello nuovo automaticamente.</p>
    <div class="upload-files">
      <b-field>
        <b-upload v-model="dropFiles" multiple drag-drop expanded>
          <section class="section">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="upload" size="is-large"></b-icon>
              </p>
              <p>Clicca o trascina i file da caricare</p>
            </div>
          </section>
        </b-upload>
      </b-field>

      <div class="tags">
      <span v-for="(file, index) in dropFiles" :key="index" class="tag is-primary">
        {{file.name}}
        <button class="delete is-small" type="button" @click="deleteDropFile(index)"></button>
      </span>
      </div>
      <b-button v-if="dropFiles.length > 0" type="is-success" @click="uploadFile">Upload</b-button>
      <b-button v-else disabled >Upload</b-button>
    </div>
  </div>

</template>
<script>

export default {
  components: {} ,
  data() {
    return {
      filenames: null,
      dropFiles: []
    }
  },
  mounted() {

  },
  methods: {
    messaggio (success, messaggio) {
      this.$buefy.dialog.alert({
        title: (success) ? 'Completato' : 'Errore',
        message: messaggio,
        type: (success) ? 'is-success' : 'is-danger',
        hasIcon: true,
        icon: (success) ? 'check-circle' : 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    uploadFile: function () {
      if (this.dropFiles.length > 0){
        let formData = new FormData();
        this.dropFiles.forEach((file, index)=>{
         // console.log(file.name)
          formData.append(index , file, file.name);
        })

        axios({
          method: 'post',
          url: window.location.origin + '/admin/uploadImgArt',
          data: formData,
        }).then(res=>{
          if (res.data.success){
            this.messaggio(true, res.data.message)
            this.dropFiles = []
          }

        })
            .catch(err => {
              this.messaggio(false, err.response.data.message)
            })
      }

    },
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },
    getImagesArticoli: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/imgProdFileName'
      }).then(res => {
        console.log(res.data)
        this.filenames = res.data[0]
      })
    }
  },
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 24px;
  margin-bottom: 5px;
}
.upload-files {
  margin-top: 20px;
}
</style>
